var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 15.968"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.479 9.521L.508 7.139a.637.637 0 01-.4-.328 1.126 1.126 0 01-.111-.492.9.9 0 01.127-.451.854.854 0 01.413-.349L14.809.078a.7.7 0 01.48-.06.917.917 0 01.435.254.917.917 0 01.254.435.692.692 0 01-.061.48L10.41 15.438a.86.86 0 01-.336.4.849.849 0 01-.447.132 1.049 1.049 0 01-.5-.129.68.68 0 01-.331-.411z"
})));
export default __webpack_public_path__ + "static/location-icon.5625b49b3d86969f497df12d9aeee98e.svg";
export { SvgLocationIcon as ReactComponent };